import { useState, useContext, useEffect, useCallback } from "react";
import { UserDataContext } from "../components/UserDataContext";
import Cookies from "js-cookie";
import { API_URL } from "../App";
import Dropzone from "react-dropzone";
import imageCompression from "browser-image-compression";
import axios from "axios";

const ImageUpload = () => {
  const { userData } = useContext(UserDataContext);
  const sessionId = Cookies.get("alzheimer");
  const [compressedImage, setCompressedImage] = useState(null);
  const [file, setFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");

  const handleImageCompression = async (file) => {
    try {
      const options = {
        maxSizeMB: 0.2,
        maxWidthOrHeight: 1024,
        useWebWorker: true,
      };
      const compressedFile = await imageCompression(file, options);

      if (compressedFile.size <= 200 * 1024) {
        setCompressedImage(URL.createObjectURL(compressedFile));
        setFile(compressedFile);
        setUploadStatus("");
      } else {
        setUploadStatus("Nie udało się skompresować obrazu poniżej 200kB.");
      }
    } catch (err) {
      setUploadStatus("Wystąpił błąd podczas kompresji obrazu.");
    }
  };

  const onDrop = (acceptedFiles) => {
    const file = acceptedFiles[0];
    if (file) {
      handleImageCompression(file);
    }
  };

  const uploadImage = useCallback(async () => {
    if (!file) {
      setUploadStatus("Brak zdjęcia do wysłania.");
      return;
    }

    console.log("userdata: ", userData);

    if (!userData || !userData.userId) {
      setUploadStatus(
        "Brak identyfikatora użytkownika. Upewnij się, że jesteś zalogowany."
      );
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    const url = API_URL + `/uploadPhoto/${sessionId}/${userData.userId}`;
    console.log("URL:", url);

    try {
      const response = await axios.post(url, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("Response:", response);

      if (response.status === 200) {
        setUploadStatus("Zdjęcie zostało pomyślnie załadowane!");
      } else {
        setUploadStatus("Wystąpił błąd podczas wysyłania.");
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania:", error);
      setUploadStatus("Błąd połączenia z serwerem.");
    }
  }, [file, sessionId, userData]);

  return (
    <div style={{ textAlign: "center", padding: "20px" }}>
      <Dropzone onDrop={onDrop} accept={{ "image/*": [] }} multiple={false}>
        {({ getRootProps, getInputProps }) => (
          <div
            {...getRootProps()}
            style={{
              border: "2px dashed #007bff",
              padding: "20px",
              cursor: "pointer",
            }}
          >
            <input {...getInputProps()} />
            <p>
              Przeciągnij i upuść zdjęcie tutaj lub kliknij, aby wybrać plik
            </p>
          </div>
        )}
      </Dropzone>

      {compressedImage && (
        <div>
          <h3>Podgląd:</h3>
          <img
            src={compressedImage}
            alt="Compressed"
            style={{ maxWidth: "100%", height: "auto" }}
          />
        </div>
      )}

      {uploadStatus && <p>{uploadStatus}</p>}

      <button onClick={uploadImage} style={{ marginTop: "10px" }}>
        Wyślij zdjęcie
      </button>
    </div>
  );
};

export default ImageUpload;
